import _sfc_main from "/opt/buildhome/repo/src/components/Navbar.vue?vue&type=script&setup=true&lang.ts";
export * from "/opt/buildhome/repo/src/components/Navbar.vue?vue&type=script&setup=true&lang.ts";
import "/opt/buildhome/repo/src/components/Navbar.vue?vue&type=style&index=0&scoped=1d60e848&lang.css";
import _export_sfc from "\0plugin-vue:export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-1d60e848"]]);
